import React from "react";
import styled from "styled-components/macro";

interface LogoProps {}

const Logo: React.FC<LogoProps> = ({}) => {
  return (
    <Anchor href={window.location.origin}>
      <LogoImg src="/logo_desktop.png" />
    </Anchor>
  );
};
const Anchor = styled.a`
  display: inline-flex;
`;
const LogoImg = styled.img`
  object-fit: contain;
  width: 100%;
`;

export default Logo;
